import { createConsumer } from '@rails/actioncable';

const CHANNEL = 'Pibox::DeliveryRoute::Chat::InboxChannel';

/**
 * DeliveryRouteInbox - contadores de no leídos de TODOS los hilos de una ruta que la sesión
 * puede leer, por un único socket (Pibox::DeliveryRoute::Chat::InboxChannel en picap_api).
 * El servidor acota los hilos a la compañía del usuario y transmite el estado completo en
 * cada cambio, así que cada difusión reemplaza a la anterior. A diferencia de
 * DeliveryRouteChatAdapter no está atado a un hilo ni necesita que el panel del chat esté
 * abierto: es lo que permite avisar de un mensaje nuevo con el panel cerrado.
 */
export class DeliveryRouteInbox {
  constructor({ deliveryRouteId }) {
    this.deliveryRouteId = deliveryRouteId;
    this.wsUrl = process.env.REACT_APP_GRPC_URL || 'https://api.picap.app/cable';
    this.consumer = null;
    this.subscription = null;
  }

  getAuthToken = () => {
    try {
      return localStorage.getItem('session_token') || null;
    } catch (error) {
      return null;
    }
  }

  /**
   * @param {(conversations: Object) => void} onBadges recibe { [pre_package_id]: { badge, reference, ... } }
   */
  subscribe = (onBadges) => {
    if (this.subscription) {
      return;
    }

    const token = this.getAuthToken();
    this.consumer = createConsumer(token ? `${this.wsUrl}?t=${token}` : this.wsUrl);
    this.subscription = this.consumer.subscriptions.create(
      { channel: CHANNEL, delivery_route_id: this.deliveryRouteId },
      {
        received: (data) => {
          const conversations = data && data.method === 'badge' ? data.data?.conversations : null;
          if (conversations) {
            onBadges(conversations);
          }
        },
      }
    );
  }

  disconnect = () => {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    if (this.consumer) {
      this.consumer.disconnect();
      this.consumer = null;
    }
  }
}
